<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
      </b-container>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md" class="d-flex">
                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['zatarka_containera_plan'], editedData['zatarka_containera_fact'])">
                        <div>
                          <span class="small-description">адрес погрузки</span>
                          {{ editedData.naselenniy_punkt || '<Здесь будет населенный пункт>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['zatarka_containera_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['zatarka_containera_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['vihod_poezda_so_stancii_otpravleniya_plan'], editedData['vihod_poezda_so_stancii_otpravleniya_fact'])">
                        <div>
                          <span class="small-description">станция отправления</span>
                          {{ editedData.station_of_otpravleniya || '<Здесь будет станцию отправления>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['vihod_poezda_so_stancii_otpravleniya_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['vihod_poezda_so_stancii_otpravleniya_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['vyhod_poezda_s_pp_plan'], editedData['vyhod_poezda_s_pp_fact'])">
                        <div>
                          <span class="small-description">погран переход</span>
                          {{ nameByPropId(editedData.pogranichnie_stancii_perehodov) || '<Здесь будет пограничные станции>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['vyhod_poezda_s_pp_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['vyhod_poezda_s_pp_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['pribitie_poezda_na_stanciyu_nazanacheniya_plan'], editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact'])">
                        <div>
                          <span class="small-description">станция прибытия</span>
                          {{ nameByPropId(editedData.station_of_incoming_id) || '<Здесь будет станция прибытия>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['pribitie_poezda_na_stanciyu_nazanacheniya_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <div>
                          <span class="small-description">адрес разгрузки</span>
                          {{ editedData.address_of_unloading || '<Здесь будет адрес разгрузки>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['dostavka_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['dostavka_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'etapy',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {},
  computed: {
    transitnoe_vremya() {
      if (!this.editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact'] || !this.editedData['zatarka_containera_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['zatarka_containera_fact'], this.editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['zatarka_containera_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['zatarka_containera_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    }
  },
  watch: {
    transitnoe_vremya(value) {
      this.editedData['transitnoe_vremya'] = value;
    },
    time_of_to(value) {
      this.editedData['time_of_to'] = value;
    },
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }
  },
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'etapy',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',
        number_of_places: 0,
        weight: 0,
        volume: 0,
        type_of_container_id: null,
        number_of_container: 1,
        sales_name: '',
        cargo_sender_name: '',
        address_g_o: '',
        contact_name_on_shipment: '',
        cargo_recipient_name: '',
        address_g_p: '',
        address_of_unloading: '',
        contact_name_on_unloading: '',
        station_of_otpravleniya: '',
        station_of_incoming_id: null,
        pogranichnie_stancii_perehodov: '',
        nomer_of_container: '',
        nomer_smgs: '',
        data_vypuska_smgs: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        zatarka_containera_plan: '',
        zatarka_containera_fact: '',
        vihod_poezda_so_stancii_otpravleniya_plan: '',
        vihod_poezda_so_stancii_otpravleniya_fact: '',
        pribitie_poezda_na_pp_plan: '',
        pribitie_poezda_na_pp_fact: '', 
        vyhod_poezda_s_pp_plan: '',
        vyhod_poezda_s_pp_fact: '',
        pribitie_poezda_na_stanciyu_nazanacheniya_plan: '',
        pribitie_poezda_na_stanciyu_nazanacheniya_fact: '',
        transitnoe_vremya: '',

        zakritie_dostavki_plan: '',
        zakritie_dostavki_fact: '',
        podacha_dt_plan: '',
        podacha_dt_fact: '',
        vypusk_dt_plan: '',
        vypusk_dt_fact: '',
        time_of_to: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      this.editedData[index] = value;
    },  
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },    
  },

  mounted() {
    this.visible = this.defaultVisible;
  },
};
</script>
<style scoped>
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}
.b-group-item-end {
  display: flex !important;
  justify-content: space-between !important;
}

.b-group-item-end b {
  text-transform: none;
}
</style>